module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4agx8"))).then(() => parcelRequire('dJXJK'));